const LIVE_BACKEND_URL = "https://greatleadersacademybackennd.onrender.com";

export function getBackendUrl() {
  return LIVE_BACKEND_URL;
}
